import axios from 'axios';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import $ from 'jquery';
import * as Yup from 'yup';
import * as APIS from '../../Config/Apis';
import { getToken } from '../../Utils/Common';
import { useComponentDidMount, withRouter } from '../../Utils/Component';
import AlertError from '../Layouts/AlertError';
import { useNavigate } from 'react-router-dom';
import { red, volcano, orange, gold, yellow, lime, green, cyan, blue, geekblue, purple, magenta, grey } from '@ant-design/colors';
import { Layout, Breadcrumb, PageHeader, Collapse, Row, Col, Button, Select, Table, Input, Space, Tag, Descriptions, Typography } from "antd";
const { Content, Footer } = Layout;
const { Panel } = Collapse;
const { Option } = Select;
const { Title } = Typography;

function TicketsDetails() {
    const token = getToken();
    const navigate = useNavigate();
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [query, setQuery] = useState(null);

    const [tableError, setTableError] = useState(null);
    const [ticket, setTicket] = useState(null);

    useComponentDidMount(() => {
        console.log(id);
        getDetails(id)
    });

    const getDetails = (id) => {
        setLoading(true);
        setTableError(null);
        const config = {
            "url": APIS.FULL_TICKETS_DETAILS + "?id=" + id,
            "method": "GET",
            "timeout": 0,
            "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
        };
        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
                setLoading(false);
                setTicket(response.data.data);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    };

    const goToTable = () => {
        navigate('/full-tickets');
    }

    const goToDetailsSchedules = (id) => {
        navigate('/full-schedules/'+id);
    }

    return (
        <Layout>
            <Content className="site-layout" style={{ padding: "0 15px" }}>
                <Breadcrumb style={{ margin: "5px 0" }}>
                    <Breadcrumb.Item><a>Home</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={goToTable.bind(this)}>Tickets</a></Breadcrumb.Item>
                    <Breadcrumb.Item>{id}</Breadcrumb.Item>
                    <Breadcrumb.Item>Details</Breadcrumb.Item>
                </Breadcrumb>
                <div className="site-layout-background" style={{ padding: 0, minHeight: 380 }}>
                    <PageHeader className="site-page-header" title="Ticket Details" />
                    <div style={{ padding: 10 }}>
                        <>
                            {tableError && <div style={{ marginBottom: "10px" }}><AlertError title="Error" message={tableError} /></div>}
                        </>
                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 8]} style={{ marginBottom: "10px" }}>
                            <Col className="gutter-row" xs={24} md={24} xl={8}>
                                <Descriptions bordered column={1} size="small" >
                                    <Descriptions.Item label="Ticket Id">{ticket ? ticket.ticket_id : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Trip Id">{ticket ? <a onClick={goToDetailsSchedules.bind(this, ticket.schedule_id)}>{ticket.schedule_id}</a> : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Travel Time">{ticket ? ticket.travel_time : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Price in RWF">{ticket ? ticket.price : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Customer">{ticket ? ticket.customer_name : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Phone Number">{ticket ? ticket.customer_phone_number : ''}</Descriptions.Item>
                                </Descriptions>
                            </Col>
                            <Col className="gutter-row" xs={24} md={24} xl={8}>
                                <Descriptions bordered column={1} size="small">
                                    
                                </Descriptions>
                            </Col>
                            <Col className="gutter-row" xs={24} md={24} xl={8}>
                                <Descriptions bordered column={1} size="small">
                                    
                                </Descriptions>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Content>
            <Footer style={{ textAlign: "center" }}>
                Copyright © 2022 AC GROUP | Tap&Go Ticketing v7.0.0
            </Footer>
        </Layout>
    )
}

export default withRouter(TicketsDetails);